<template>
  <div >
    <!-- Tabs with card integration -->
    <!-- <b-form @submit.prevent="reRender()"> -->
      <!-- <pre>index: {{this.device}} </pre> -->
      <b-card no-body>
        <b-tabs pills v-model="tabIndex" small card>
          <b-tab title="Profile">
            <profile :device="device"></profile>
          </b-tab>
          <b-tab title="Firmware">
            <firmware :device="device"></firmware>           
          </b-tab>
          <!-- <b-tab title="Config Files">
          </b-tab> -->
          <!-- <b-tab title="....">
          </b-tab> -->
        </b-tabs>
      </b-card>
    <!-- </b-form> -->
  </div>
<!--   <div v-else>
    No data for this device
  </div> -->
</template>

<script>
import Multiselect from 'vue-multiselect';
import Profile from "@/readynet/devices/preferences/Profile";
import Firmware from "@/readynet/devices/preferences/Firmware";

export default {
  components: {
    'profile': Profile,
    'firmware' : Firmware,
  },
  props: {
    device: {
      type: Object,
      default: function() {
        return {}
      }
    },
    changed: {
      type: Array,
      // default: () =>([]),
    },
    changes: {
      type: Object,
      // default: () =>([]),
    },
  },

  data() {
    return {
      tabIndex: 0
    }
  },

  mounted() {},
  methods: {},
}
</script>
